import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const MarkerLocation = ({
  width = "14",
  height = "20",
  style,
  className,
  fillClassName,
  fillColor,
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 14 20"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      fillRule="evenodd"
      className={fillClassName}
      d="M0 7.265c0-3.87 3.13-7 7-7s7 3.13 7 7c0 4.17-4.42 9.92-6.23 12.11-.4.48-1.13.48-1.53 0C4.42 17.185 0 11.435 0 7.265zm4.5 0a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z"
    />
  </svg>
);

export default MarkerLocation;
